import { render } from "./NotificationEdit.vue?vue&type=template&id=7e06ad20"
import script from "./NotificationEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationEdit.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/notification/components/NotificationEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e06ad20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e06ad20', __exports__)) {
    api.reload('7e06ad20', __exports__)
  }
  
  module.hot.accept("./NotificationEdit.vue?vue&type=template&id=7e06ad20", () => {
    api.rerender('7e06ad20', render)
  })

}


export default __exports__